export default __webpack_public_path__ + "static/logo-pwc-cutup-f34940467913b16e8312d2cc444791fc.svg";